import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import {
  showCreateAccount,
  showRequestResetPassword,
  submitLogInForm,
  isValidEmail,
} from '../../user';
import { Login } from '../Login';

const mapDispatchToProps = (dispatch, ownProps) => {
  const { loginCallback, shouldRedirectToDashboard } = ownProps;
  return {
    onSubmit: data =>
      dispatch(submitLogInForm(data, loginCallback, shouldRedirectToDashboard)),
    clickCreateAccount: () => dispatch(showCreateAccount('Create Account')),
    clickRequestResetPassword: () =>
      dispatch(showRequestResetPassword('Forgot Password')),
  };
};

const mapStateToProps = ({}, { feedUrl, signupUrl }) => ({
  feedUrl,
  signupUrl,
});

function validateLoginForm(formValues) {
  const { email, password } = formValues;
  const errors = {};
  if (!email) errors.email = 'Email is required';
  if (email && !isValidEmail(email)) errors.email = 'Email is invalid';
  if (!password) errors.password = 'Password is required';
  return errors;
}

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
    validate: validateLoginForm,
  })(Login)
);

export { LoginContainer };
